export var ModelType;
(function (ModelType) {
  ModelType["dae"] = "dae";
  ModelType["glb"] = "glb";
})(ModelType || (ModelType = {}));